export function useUrlSearchParams() {
    function getParam(param: string) {
        return (new URLSearchParams(window.location.search) || '').get(param);
    }

    return {getParam};
}
